import router from './router'
import store from './store'
import { getUserInfo } from "@/store/mutation-types"

router.beforeEach(async (to, from, next) => {
  const hasToken = store.getters['user/token']
  if (hasToken) {
      const userInfo = getUserInfo();
      if (userInfo && userInfo.mobile) {
        if (to.matched.length === 0){
          next({ path: '/error/404' })
        }else next() 
      } else {
        try {
          await store.dispatch("user/getInfo");
          await store.dispatch("contract/getContractInfo");
          // 判断是否有菜单数据
          if (store.state.permission.addRoutes.length>0) {
            next()
          } else {
            const accessRoutes = await store.dispatch('permission/generateRoutes');
            if (accessRoutes.length>0){
              // 动态更新路由name为home静态路由的redirect
              router.addRoute({
                path:'/',
                name:'TicketHomePage',
                redirect:accessRoutes[0].path
              })
            }
            if (accessRoutes.length) {
              accessRoutes.forEach(it => {
                router.addRoute(it)
              })
              next({ ...to, replace: true })
            } else {
              next('/error/404')
            }
          }
        } catch (error) {
          console.log(error)
          // await store.dispatch("user/resetToken");
          // window.open(`${process.env.VUE_APP_EXTERNAL_LINK}/login?redirect=${window.location.href}`, '_self')
        }
      }
  } else {
   window.open(`${process.env.VUE_APP_EXTERNAL_LINK}/login?redirect=${window.location.href}`, '_self')
  }
})